import Step from '../enums/Step'

export interface StepItemData {
  stepId: number
  description: string
  isShown: boolean
}

export const stepItemList: StepItemData[] = [
  {
    stepId: Step.One,
    description: 'Dates',
    isShown: true
  },
  {
    stepId: Step.Two,
    description: 'Vehicle',
    isShown: true
  },
  {
    stepId: Step.Three,
    description: 'Your info',
    isShown: true
  },
  {
    stepId: Step.Four,
    description: 'Payment',
    isShown: false
  },
  {
    stepId: Step.Five,
    description: 'Review',
    isShown: true
  },
  {
    stepId: Step.Six,
    description: 'Review',
    isShown: false
  }
]

export default stepItemList
